const ExtractMain = () => import("../components/extract/main")
const ExtractHistories = () => import("../components/extract/Histories")
const Parser = () => import("../components/extract/ParseTest")
const SchedulerMain = () => import("../components/scheduler/Main")
const SchedulerResultList = () => import("../components/scheduler/ResultList")
const SchedulerResultView = () => import("../components/scheduler/ResultView")
const TemplateMain = () => import("../components/template/Main")
const Processor = () => import("../components/processor/Main")
const Dashboard = () => import("../components/dashboard/Main")


const path = [
    {
        path: "/extract-histories",
        name: "extract-histories",
        component: ExtractHistories,
        meta: {title: "抽出履歴"},
    },
    {
        path: "/extract-main",
        name: "extract-main",
        component: ExtractMain,
        mata: {title: "要素抽出"},
    },
    {
        path: "/dashboard",
        name: "dashboard",
        component: Dashboard,
        mata: {title: "ダッシュボード"},
    },
    {
        path: "/processor",
        name: "processor",
        component: Processor,
        mata: {title: "データ加工"},
    },
    {
        path: "/parser",
        name: "parser",
        component: Parser,
        props: {from: "router"},
        mata: {title: "パーサー"},
    },
    {
        path: "/scheduler-main",
        name: "scheduler-main",
        component: SchedulerMain,
        mata: {title: "抽出定期予約"},
    },
    {
        path: "/template-main",
        name: "template-main",
        component: TemplateMain,
        mata: {title: "テンプレート"},
    },
    {
        path: "/scheduler-result-list",
        name: "scheduler-result-list",
        component: SchedulerResultList,
        mata: {title: "予約結果"},
    },
    {
        path: "/scheduler-result-view",
        name: "scheduler-result-view",
        component: SchedulerResultView,
        mata: {title: "予約結果確認"},
    },
    {
        path: "/scheduler/update/:scd_id",
        name: "scheduler-update",
        component: SchedulerMain,
        meta: { title: "スケジューラー更新" },
        props: true,
    },
]

export default path
